if ($('#howToUse').length) {
    $('.howToUse__items').slick({
        slidesToShow: 1,
        dots: true,
        infinite: false,
        mobileFirst: true,
        autoplay: false,
        centerMode: true,
        centerPadding: '30px',
        responsive: [
            {
                breakpoint: 768,
                settings: "unslick"
            }
        ]
    });

    if (!$('#howToUse').prev().find('section:last-of-type').hasClass('has-bgColor')) {
        $('#howToUse').css("padding-top", "0");
    }
}